"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _NavMarker = _interopRequireDefault(require("react-rhumb/NavMarker"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _DirectorySidebarContainer = _interopRequireDefault(require("../containers/DirectorySidebarContainer"));

var _SortingBar = _interopRequireDefault(require("./SortingBar"));

var _GoodsGrid = _interopRequireDefault(require("./GoodsGrid"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

var _UIPaginator = _interopRequireDefault(require("UIComponents/paginator/UIPaginator"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _GoodFiltersAndPage = _interopRequireDefault(require("../constants/GoodFiltersAndPage"));

var _Limits = _interopRequireDefault(require("../constants/Limits"));

var _LoadingWrapper = _interopRequireDefault(require("./LoadingWrapper"));

var _PageLimitPicker = _interopRequireDefault(require("./PageLimitPicker"));

var _utils = require("../utils/utils");

var _langUtils = require("../utils/langUtils");

var _LoadingErrorPage = _interopRequireDefault(require("./LoadingErrorPage"));

var LoadingErrorComponent = function LoadingErrorComponent() {
  return _react.default.createElement(_NavMarker.default, {
    name: "DIRECTORY_ERROR_LOAD"
  }, _react.default.createElement(_LoadingErrorPage.default, null));
};

var _default = _react.default.createClass({
  displayName: "DirectoryPage",
  propTypes: {
    auth: _react.PropTypes.object.isRequired,
    directoryData: _react.PropTypes.object.isRequired,
    onPageChange: _react.PropTypes.func.isRequired,
    onGoodFilterChange: _react.PropTypes.func.isRequired,
    trackAdjustedFilter: _react.PropTypes.func.isRequired,
    trackLinkClick: _react.PropTypes.func.isRequired,
    categoryFilter: _react.PropTypes.string.isRequired
  },
  handleClearFilters: function handleClearFilters() {
    this.props.onGoodFilterChange((0, _utils.getClearedSidebarFilters)());
  },
  renderPaginatorIfMultiplePages: function renderPaginatorIfMultiplePages(directoryData, onPageChange) {
    var totalCount = directoryData.get('numGoodsMatchingFilterCriteria');
    var pageSize = directoryData.getIn(['goodFiltersAndPage', _GoodFiltersAndPage.default.LIMIT], _Limits.default.SMALL);
    var pageCount = Math.ceil(totalCount / pageSize);

    if (pageCount > 1) {
      return _react.default.createElement(_UIFlex.default, {
        justify: "center",
        align: "baseline",
        className: "text-center m-top-2"
      }, _react.default.createElement(_UIPaginator.default, {
        className: "integrate-directory-paginator",
        onPageChange: onPageChange,
        page: directoryData.getIn(['goodFiltersAndPage', _GoodFiltersAndPage.default.PAGE], 0) + 1,
        pageCount: pageCount
      }), _react.default.createElement(_PageLimitPicker.default, {
        limit: pageSize,
        total: totalCount,
        onChange: this.props.onGoodFilterChange
      }));
    }

    return null;
  },
  renderZeroState: function renderZeroState(zeroStateType) {
    var goodFilters = this.props.directoryData.get('goodFiltersAndPage');
    var textValues = {
      categoryName: (0, _utils.replaceAllProductsCategoryName)((0, _langUtils.getCategoryOptionText)(goodFilters.get(_GoodFiltersAndPage.default.SUB_TYPE)).toLowerCase()),
      searchTerm: goodFilters.get(_GoodFiltersAndPage.default.SEARCH_TERM)
    };
    return _react.default.createElement(_NavMarker.default, {
      name: "DIRECTORY_EMPTY_STATE_LOAD"
    }, _react.default.createElement(_UIErrorMessage.default, {
      "data-test-id": "goods-grid-empty-state",
      illustration: "empty-state-charts",
      title: (0, _unescapedText.default)("goodsZeroState." + zeroStateType + ".title", textValues)
    }, _react.default.createElement("p", null, _react.default.createElement(_FormattedJSXMessage.default, {
      message: "goodsZeroState." + zeroStateType + ".message_jsx",
      options: {
        onClick: this.handleClearFilters
      },
      elements: {
        Button: _UIButton.default
      }
    }))));
  },
  renderGoodsGridIfResults: function renderGoodsGridIfResults() {
    var _this$props = this.props,
        directoryData = _this$props.directoryData,
        trackLinkClick = _this$props.trackLinkClick;

    if (directoryData.get('goods').size) {
      return _react.default.createElement(_NavMarker.default, {
        name: "DIRECTORY_GRID_LOAD"
      }, _react.default.createElement(_GoodsGrid.default, {
        goods: directoryData.get('goods'),
        trackLinkClick: trackLinkClick
      }));
    }

    if (directoryData.getIn(['goodFiltersAndPage', _GoodFiltersAndPage.default.SEARCH_TERM])) {
      if (!(0, _utils.areAllSidebarFiltersAtInitialValue)(directoryData.get('goodFiltersAndPage'))) {
        return this.renderZeroState('searchWithFilters');
      }

      return this.renderZeroState('searchWithNoFilters');
    }

    if (!(0, _utils.areAllSidebarFiltersAtInitialValue)(directoryData.get('goodFiltersAndPage'))) {
      return this.renderZeroState('noSearchWithFilters');
    }

    return null;
  },
  render: function render() {
    var _this$props2 = this.props,
        auth = _this$props2.auth,
        directoryData = _this$props2.directoryData,
        onPageChange = _this$props2.onPageChange,
        onGoodFilterChange = _this$props2.onGoodFilterChange,
        categoryFilter = _this$props2.categoryFilter,
        trackAdjustedFilter = _this$props2.trackAdjustedFilter,
        trackLinkClick = _this$props2.trackLinkClick;
    return _react.default.createElement("div", {
      className: "directory-container m-y-4"
    }, _react.default.createElement("div", {
      className: "page-content-wrapper"
    }, _react.default.createElement(_UISection.default, {
      className: "directory-main-content-area"
    }, _react.default.createElement(_UIFlex.default, null, _react.default.createElement(_UIBox.default, {
      basis: "200px",
      className: "m-right-8",
      shrink: 0
    }, _react.default.createElement(_DirectorySidebarContainer.default, {
      auth: auth,
      onGoodFilterChange: onGoodFilterChange,
      trackAdjustedFilter: trackAdjustedFilter,
      trackLinkClick: trackLinkClick
    })), _react.default.createElement(_UIBox.default, {
      grow: 1
    }, _react.default.createElement(_LoadingWrapper.default, {
      ErrorComponent: LoadingErrorComponent,
      requestStatus: directoryData.get('requestStatus')
    }, _react.default.createElement(_UISection.default, null, _react.default.createElement(_SortingBar.default, {
      goodFilters: directoryData.get('goodFiltersAndPage'),
      numGoodsMatchingFilterCriteria: directoryData.get('numGoodsMatchingFilterCriteria', 0),
      onGoodFilterChange: onGoodFilterChange,
      categoryFilter: categoryFilter
    })), this.renderGoodsGridIfResults(), this.renderPaginatorIfMultiplePages(directoryData, onPageChange)))))));
  }
});

exports.default = _default;
module.exports = exports.default;